import { ModuleOverview } from 'types/module';
import { ImageSection } from './ImageSection/ImageSection';
import { ContentSection } from './ContentSection/ContentSection';
import { TagCompleted } from './ProgressTags/Completed/TagCompleted';
import { BarCompleted } from './ProgressBars/Completed/BarCompleted';
import { TagInProgress } from './ProgressTags/InProgress/TagInProgress';
import { PartialProgressBar } from './ProgressBars/InProgress/PartialProgressBar';

import './ModuleCard.scss';
import { useNavigateToModule } from './useNavigateToModule';
import { ComingSoonTag } from './ProgressTags/ComingSoon/ComingSoonTag';

type Props = {
  module: ModuleOverview;
};

export const ModuleCard = ({ module }: Props) => {
  const navigateToModule = useNavigateToModule(module.slug);

  const navigate = () => {
    if (!module.comingSoon) {
      navigateToModule();
    }
  };

  return (
    <>
      <div className={module.comingSoon ? 'module-card' : 'module-card  module-card__enabled'} onClick={navigate}>
        {module.comingSoon
          ? ComingSoonCard(module)
          : module.progress === 100
          ? CompletedCard(module)
          : module.progress > 0
          ? InProgressCard(module)
          : NotStartedCard(module)}
      </div>
    </>
  );
};

const NotStartedCard = (module: ModuleOverview) => (
  <>
    <ImageSection {...module} />
    <ContentSection {...module} />
  </>
);

const ComingSoonCard = (module: ModuleOverview) => (
  <>
    <ImageSection {...module}>
      <ComingSoonTag />
    </ImageSection>
    <ContentSection {...module} />
  </>
);

const CompletedCard = (module: ModuleOverview) => (
  <>
    <ImageSection {...module}>
      <TagCompleted />
    </ImageSection>
    <ContentSection {...module}>
      <BarCompleted />
    </ContentSection>
  </>
);

const InProgressCard = (module: ModuleOverview) => (
  <>
    <ImageSection {...module}>
      <TagInProgress progress={module.progress} />
    </ImageSection>
    <ContentSection {...module}>
      <PartialProgressBar progress={module.progress} />
    </ContentSection>
  </>
);
